import React, { useMemo } from 'react';
import axios from 'axios';
import { useApp } from '../context/AppContext';
import { LogisticsReport } from '../components/logistics/LogisticsReport';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function Logistics() {
  const { selectedProject } = useApp();
  const pid = selectedProject?.id;
  const api = useMemo(() => {
    const base = `${API_URL}/api/logistics/projects/${pid}`;
    return {
      get: (p, cfg) => axios.get(base + p, cfg),
      post: (p, body) => axios.post(base + p, body),
      put: (p, body) => axios.put(base + p, body),
      saveLimit: (v) => axios.put(`${base}/settings`, { frete_gratis_limite: v }),
    };
  }, [pid]);
  if (!pid) return <div className="text-center py-12">Selecione um projeto</div>;
  return <LogisticsReport key={pid} api={api} />;
}
